import React from 'react';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import HomePage from './pages/public/HomePage';
import AboutPage from './pages/public/AboutPage';
import ProductsPage from './pages/public/ProductsPage';
import BlogPage from './pages/public/BlogPage';
import BlogDetailPage from './pages/public/BlogDetailPage';
import ContactPage from './pages/public/ContactPage';
import ServiceDetailPage from './pages/public/ServiceDetailPage';
import OrderPage from './pages/public/OrderPage';
import ReferralOrderPage from './pages/public/ReferralOrderPage';
import DynamicPage from './pages/public/DynamicPage';
import NotFoundPage from './pages/public/NotFoundPage';
import ErrorBoundary from './components/public/ErrorBoundary';

function App() {
  return (
    <ErrorBoundary>
      <BrowserRouter>
      <Routes>
        {/* Public Website */}
        <Route path="/" element={<HomePage />} />
        <Route path="/about" element={<AboutPage />} />
        <Route path="/products" element={<ProductsPage />} />
        <Route path="/blog" element={<BlogPage />} />
        <Route path="/blog/:slug" element={<BlogDetailPage />} />
        <Route path="/contact" element={<ContactPage />} />
        <Route path="/services/:slug" element={<ServiceDetailPage />} />
        <Route path="/order" element={<OrderPage />} />
        <Route path="/order/:code" element={<ReferralOrderPage />} />
        <Route path="/404" element={<NotFoundPage />} />
        <Route path="/:slug" element={<DynamicPage />} />
        <Route path="*" element={<NotFoundPage />} />
      </Routes>
      </BrowserRouter>
    </ErrorBoundary>
  );
}

export default App;